import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import policies from "../data/privacyPolicies.json";
import "../styles/pages/privacy_policy_page.css";

const policyPaths = {
  ru: "/rus/about/mobile-politics",
  kg: "/kg/about/mobile-politics",
};

const PrivacyPolicyPage = ({ language = "ru" }) => {
  const policy = policies[language];
  const isKyrgyz = language === "kg";

  useEffect(() => {
    const previousTitle = document.title;
    const previousLanguage = document.documentElement.lang;
    document.title = `${policy.title} — Bishkek Petroleum`;
    document.documentElement.lang = isKyrgyz ? "ky" : "ru";

    return () => {
      document.title = previousTitle;
      document.documentElement.lang = previousLanguage;
    };
  }, [policy.title, isKyrgyz]);

  return (
    <div className="privacy-policy-page">
      <Header />
      <main className="privacy-policy-content" lang={isKyrgyz ? "ky" : "ru"}>
        <div className="privacy-policy-toolbar">
          <Link to="/" className="privacy-policy-home">
            {isKyrgyz ? "Башкы бет" : "Главная"}
          </Link>
          <nav className="privacy-policy-languages" aria-label={isKyrgyz ? "Тилди тандоо" : "Выбор языка"}>
            <Link to={policyPaths.ru} lang="ru" hrefLang="ru" aria-current={!isKyrgyz ? "page" : undefined}>
              Русский
            </Link>
            <Link to={policyPaths.kg} lang="ky" hrefLang="ky" aria-current={isKyrgyz ? "page" : undefined}>
              Кыргызча
            </Link>
          </nav>
        </div>

        <article>
          <h1>{policy.title}</h1>
          <a className="privacy-policy-download" href={`/documents/privacy-policy-${language}.docx`} download>
            {isKyrgyz ? "Документти жүктөп алуу (DOCX)" : "Скачать документ (DOCX)"}
          </a>
          {policy.sections.map((section, sectionIndex) => (
            <section key={sectionIndex} aria-labelledby={`policy-section-${sectionIndex + 1}`}>
              <h2 id={`policy-section-${sectionIndex + 1}`}>{sectionIndex + 1}. {section.title}</h2>
              {section.paragraphs.map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex}>
                  {paragraph.split(/(support@bpetroleum\.kg)/g).map((part, partIndex) => (
                    part === "support@bpetroleum.kg"
                      ? <a key={partIndex} href="mailto:support@bpetroleum.kg">{part}</a>
                      : part
                  ))}
                </p>
              ))}
            </section>
          ))}
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
